import { render, staticRenderFns } from "./ScoresExporter.vue?vue&type=template&id=15b75e65"
import script from "./ScoresExporter.vue?vue&type=script&lang=ts"
export * from "./ScoresExporter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports